import React from 'react';
import Select from 'react-select';
import Checkbox from '../form/Checkbox';

import CriterionApi from '../../api/criterion';
import Message from '../form/Message';

const UNPLANNED_OPTION = {
    value: 'unplanned',
    label: 'Unplanned',
};

const CHECKIN_OPTIONS = [
    {
        value: 1,
        label: 1,
    },
    {
        value: 2,
        label: 2,
    },
    {
        value: 3,
        label: 3,
    },
];

class ManagePlanCriterion extends React.Component {
    constructor(props, context) {
        super(props, context);

        let initialCheckin = 'unplanned';
        if (props.criterion) {
            initialCheckin = props.criterion.checkin || 'unplanned';
        }

        this.state = {
            currentCheckin: initialCheckin,
            criterion: props.criterion,
            errorMessage: '',
            loading: false,
            active: this.props.criterion.status === 'Disabled' ? false : true,
        };

        this.updateCheckin = this.updateCheckin.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.criterion !== prevState.criterion) {
            return { criterion: nextProps.criterion, loading: false };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.criterion !== this.props.criterion) {
            this.setState({ criterion: this.props.criterion });
        }

        if (prevState.currentCheckin !== this.props.criterion.checkin) {
            this.setState({ currentCheckin: this.props.criterion.checkin });
        }
    }

    componentDidMount() {
        this.setState({
            criterion: this.props.criterion,
            checkinDisabled: this.props.criterion.status === 'Prevalidated',
        });
    }

    handlePrevalidatedChanged = async criterionChecked => {
        this.setState({ loading: true });
        let changes = {
            checkin: '1',
            status: criterionChecked === true ? 'Prevalidated' : 'Not Started',
        };
        try {
            await CriterionApi.updateCriterionForOrganization(this.props.criterion.id, changes).then(result => {
                this.setState(
                    {
                        criterion: Object.assign(this.state.criterion, result.data),
                        checkinDisabled: criterionChecked,
                        criterionSaving: false,
                        currentCheckin: '1',
                    },
                    () => {
                        this.props.onUpdate();
                    }
                );
            });
        } catch (e) {}
    };

    activation = async () => {
        this.setState({ loading: true });
        // Backwards because we have not updated state with the new state yet.
        let changes = {
            status: this.state.active ? 'Disabled' : 'Not Started',
        };
        try {
            await CriterionApi.updateCriterionForOrganization(this.props.criterion.id, changes).then(result => {
                this.setState(
                    {
                        criterion: Object.assign(this.state.criterion, result.data),
                        loading: false,
                        active: !this.state.active,
                    },
                    () => {
                        this.props.onUpdate();
                    }
                );
            });
            this.props.updateCounts(this.props.criterion.parent_code, this.state.active ? 1 : -1);
        } catch (e) {}
    };

    activateCheckbox = status => {
        // A grouped criterion that is required will have isRequired set to true.
        const thisCriterionIsRequired = this.props.criterion.isRequired === true ? true : false;

        // A criterion with a grouping of null / 0 means all items are required.
        const allItemsOfTheGroupAreRequired = this.props.criterion.grouping === null || this.props.criterion.grouping === 0;

        if (allItemsOfTheGroupAreRequired || thisCriterionIsRequired) {
            // Don't show an active checkbox for this criterion.
            return;
        }

        // This criterion is has a non-zero grouping, and is not required.
        // Show the active checkbox.
        return (
            <div className={'ActiveCriterion'}>
                <Checkbox label="Active" defaultChecked={this.state.active} onChange={this.activation} />
            </div>
        );
    };

    updateCheckin(_newValue) {
        let newValue = _newValue;

        this.setState({ errorMessage: '' });

        console.log(newValue);
        if (newValue === 'unplanned') {
            newValue = null;
        }
        CriterionApi.updateCheckin(this.state.criterion.id, newValue)
            .then(result => {
                //console.log('Got api result: ' + JSON.stringify(result));
                this.props.onUpdate();
            })
            .catch(err => {
                let errorMessage = 'Error updating criterion.';
                if (err && err.response && err.response.data && err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
                this.setState({ errorMessage: errorMessage });
            });

        this.setState({
            currentCheckin: _newValue,
        });
    }

    render() {
        const criterion = this.state.criterion;

        // If the selection is set to "Unplanned", we send null the api.
        // Setting the value of the Select menu to null will not display any items selected.
        // If it is null, set it as unplanned.
        const checkin = this.state.currentCheckin || 'unplanned';

        let { status } = this.state.criterion;
        const { excerpt = null } = this.props;
        status = status === 'Prevalidated' ? true : false;

        let opts = [].concat(CHECKIN_OPTIONS);
        if (this.state.criterion.type === 'Elective') {
            opts.push(UNPLANNED_OPTION);
        }
        if (this.state.loading) {
            return (
                <div className="ManagePlanCriterion Saving">
                    <div>Saving ... </div>
                </div>
            );
        } else {
            return (
                <div className={`ManagePlanCriterion ${excerpt ? 'Tabbed' : ''}`}>
                    <div className="MPCheckin">
                        <div className={this.state.checkinDisabled ? 'disabled' : 'enabled'}>
                            <Select
                                name="checkin"
                                disabled={this.state.checkinDisabled}
                                options={opts}
                                value={checkin}
                                onChange={newValue => {
                                    this.updateCheckin(newValue.value);
                                }}
                                clearable={false}
                                searchable={false}
                            />
                            <label>Check-in</label>
                        </div>
                        <Checkbox label="Prevalidated" defaultChecked={status} onChange={this.handlePrevalidatedChanged} />
                    </div>
                    <div className="MPComponents">
                        {criterion.minimum_components || 0}
                        <label>Components</label>
                    </div>
                    <div className="MPDescription">
                        <span className="MPDescription__title">{criterion.description}</span>
                        <span className="MPDescription__meta">
                            [{criterion.type}] -&nbsp; ({criterion.concept_code}) {excerpt ? criterion.name : criterion.concept} -&nbsp; ({criterion.competency_code}) {criterion.competency}
                        </span>
                        <Message error={this.state.errorMessage} />
                    </div>
                    {this.activateCheckbox(status)}
                </div>
            );
        }
    }
}

export default ManagePlanCriterion;

/*
<div className="MPCredits">
    {criterion.credits || 0}
    <label>Credits</label>
</div>
*/
